import React from 'react'
import Select from 'react-select'
import {FormGroup, Label, Input, Button, Col} from 'reactstrap'
import DatePicker from './DatePicker'
import SelectHour from './SelectHour'
import SelectPassengers from './SelectPassengers'
import moment from "moment/moment"

export default class RequestForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            pickLocation: {value: this.props.start_location || 2},
            end_location: '',
            pickError: false,
            pickLocations: this.props.locations || [],
            dropVisible: false
        }
    }

    validateForm = () => {
        const {pickLocation} = this.state
        if(!(pickLocation && parseInt(pickLocation.value) > 0)) {
            alert(this.props.t.pick_label + ' - Required')
            return false
        }
        return true
    }

    book = () => {
        if (this.validateForm()) {
            const {pickLocation, dropVisible} = this.state
            const r = {
                start_location: pickLocation && pickLocation.value || '',
                end_location: encodeURIComponent(this.state.end_location),
                start_date: this.start_date.getSelection(),
                start_hour: this.start_hour.getSelection(),
                passengers: this.passengers.getSelection(),
                return_trip: dropVisible || '',
                end_date: dropVisible && this.end_date.getSelection() || '',
                end_hour: dropVisible && this.end_hour.getSelection() || '',
                source: this.props.source
            }
            this.submitSearch(r)
        }
    }

    submitSearch = (r) => {
        window.location.href = '/transfers/client_details?' +
            'start_location=' + r.start_location +
            '&end_location=' + r.end_location +
            '&start_date=' + r.start_date +
            '&start_hour=' + r.start_hour +
            '&passengers=' + r.passengers +
            '&return_trip=' + r.return_trip +
            '&end_date=' + r.end_date +
            '&end_hour=' + r.end_hour +
            '&locale=' + this.props.locale +
            '&source=' + r.source
    }

    renderPick = () => {
        const {pickLocation} = this.state
        const placeholder = <span><i className={'fa fa-map-marker mr-2'}/> {this.props.t.pick_empty}</span>
        return (
            <div id={'pickL'}>
                {!this.state.pickError &&
                <div className={'small ml-2'}>{this.props.t.pick_label}</div>
                }
                {this.state.pickError &&
                <div className={'small hasError'}>{t.search.error_pick_l}{' '}{this.props.t.e_required}</div>
                }
                <Select
                    name={'pick_location_id'}
                    placeholder={placeholder}
                    value={pickLocation && pickLocation.value}
                    onChange={(pickLocation) => {
                        this.setState({pickLocation: pickLocation, pickError: false})
                        localStorage.setItem('start_location', pickLocation && pickLocation.value)
                    }}
                    options={this.state.pickLocations}
                    style={this.state.pickError ? {'border': '1px solid red', 'background': '#fff6f6'} : {}}
                />
            </div>
        )
    }

    onChangeStartDate = (start_date) => {
        this.end_date && this.end_date.updateFromStart(start_date)
    }

    render() {
        return (
            <div className={'mx-2'} id={'reqForm'}>
                {this.renderPick()}
                {!this.props.tour &&
                <div>
                    <div className={'small mt-4 ml-2'}>
                        {this.props.t.drop_label}
                    </div>
                    <div>
                        <Input type="text" name="end_location" placeholder={this.props.t.drop_empty}
                               value={this.state.end_location}
                               onChange={e => this.setState({end_location: e.target.value})}/>
                    </div>
                </div>
                }
                <FormGroup row className={'mt-4'}>
                    <Col sm={4}>
                        <div className={'small ml-2'}>{this.props.t.start_date}</div>
                        <div className={'text-dark'}>
                            <DatePicker ref={e => this.start_date = e} onChangeDate={this.onChangeStartDate}/>
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className={'small ml-2'}>{this.props.t.start_hour}</div>
                        <div>
                            <SelectHour t={this.props.t} ref={e => this.start_hour = e}/>
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className={'small ml-2'}>{this.props.t.passengers}</div>
                        <div>
                            <SelectPassengers t={this.props.t} ref={e => this.passengers = e}/>
                        </div>
                    </Col>
                </FormGroup>
                {!this.props.tour &&
                <FormGroup check>
                    <Label check className={'mt-2 ml-2'}>
                        <Input type="checkbox" checked={this.state.dropVisible}
                               onChange={() => {
                                   this.setState({dropVisible: !this.state.dropVisible})
                               }}/>{' '}
                        {this.props.t.return_trip}
                    </Label>
                </FormGroup>
                }
                {this.state.dropVisible &&
                <div className={'mt-4'}>
                    <FormGroup row>
                        <Col sm={6}>
                            <div className={'small ml-2'}>{this.props.t.end_date}</div>
                            <div className={'text-dark'}>
                                <DatePicker ref={e => this.end_date = e} date={this.start_date && this.start_date.getSelection()}/>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className={'small ml-2'}>{this.props.t.end_hour}</div>
                            <div>
                                <SelectHour t={this.props.t} ref={e => this.end_hour = e}/>
                            </div>
                        </Col>
                    </FormGroup>
                </div>
                }
                <FormGroup row>
                    <Col>
                        <div className={'pull-right mt-4'}>
                            <Button className={'btn-lg btn-warning'} onClick={this.book}>{this.props.t.continue}</Button>
                        </div>
                    </Col>
                </FormGroup>
            </div>
        )
    }

}